import { Center, Text } from "@chakra-ui/react";
import { Button } from "@components/button";
import styled from "@emotion/styled";
import { FONT } from "@styles/common";

export const CustomCenter = styled(Center)`
    height: 72px;
    justify-content: flex-end;
    background: ${({ theme }) => theme.COLOR.white};
    align-items: center;
`;

export const CustomText = styled(Text)`
    ${FONT("pretendard", 16, 500)}

    & span {
        ${FONT("pretendard", 24, 700)}
        color: ${({ theme }) => theme.COLOR.pink[200]}
    }
`;

export const CustomButton = styled(Button)`
    ${FONT("pretendard", 16, 700)}
    color: ${({ theme }) => theme.COLOR.pink[200]};
    border: 1px solid ${({ theme }) => theme.COLOR.pink[200]};

    &:hover {
        color: ${({ theme }) => theme.COLOR.white};
        background: ${({ theme }) => theme.COLOR.pink[200]};
        border: none;
    }
`;
